/**
 * @generated SignedSource<<7b006dff0bd2eaa49363bce688c333db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type salesOrderBaseInlineFragment$data = {
  readonly id: string;
  readonly externalRef: string;
  readonly accountId: string | null;
  readonly userId: string | null;
  readonly customerEmail: string;
  readonly customerFirstName: string | null;
  readonly customerLastName: string | null;
  readonly status: string;
  readonly totalAmount: number;
  readonly grandAmount: number;
  readonly currencyCode: string;
  readonly meta: any | null;
  readonly eventRecurringId: string | null;
  readonly createdAt: any | null;
  readonly updatedAt: any | null;
  readonly deletedAt: any | null;
  readonly payment: {
    readonly " $fragmentSpreads": FragmentRefs<"paymentBaseInlineFragment">;
  } | null;
  readonly " $fragmentType": "salesOrderBaseInlineFragment";
};
export type salesOrderBaseInlineFragment$key = {
  readonly " $data"?: salesOrderBaseInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"salesOrderBaseInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "salesOrderBaseInlineFragment"
};

(node as any).hash = "e6ee0c56cb585e358f0f1b99e6f8eac3";

export default node;
